var map = {
	"./AlarmRecord/routes.tsx": 56236,
	"./AssetsAlarmOverview/routes.tsx": 59008,
	"./BatteryThermalDiagram/routes.tsx": 79789,
	"./Bsa/routes.tsx": 42861,
	"./BsaConfigScreen/routes.tsx": 61387,
	"./BsaDataCollectionConfigNew/routes.tsx": 46255,
	"./BsaHistoryData/routes.tsx": 48291,
	"./BsaHourlyElecReport/routes.tsx": 15919,
	"./BsaList/routes.tsx": 57749,
	"./BsaListNew/routes.tsx": 97976,
	"./BsaNewBasic/routes.tsx": 7438,
	"./BsaNewSteps/routes.tsx": 64770,
	"./BsaOperationDashBoard/routes.tsx": 87868,
	"./BsaRealTimeMonitor/routes.tsx": 92921,
	"./BsaRecordList/routes.tsx": 91247,
	"./ChargingStationManagement/routes.tsx": 97230,
	"./CircuitConfigure/routes.tsx": 9074,
	"./CircuitManage/routes.tsx": 29026,
	"./DeviationAlarm/routes.tsx": 78261,
	"./DispatchDeviationRule/routes.tsx": 79452,
	"./ElectricityConsumptionAnalysis/routes.tsx": 63994,
	"./ElectricityPriceManage/routes.tsx": 14101,
	"./Energy/routes.tsx": 38069,
	"./EnergyAssetProjectIncome/routes.tsx": 14973,
	"./EnergyAssetsOverview/routes.tsx": 48047,
	"./EnergyDispatchManagement/routes.tsx": 17504,
	"./EnergyGateway/routes.tsx": 51163,
	"./EnergySavingBatchConfig/routes.tsx": 1761,
	"./EnergySavingRate/routes.tsx": 71356,
	"./EnergyStorageStationOverview/routes.tsx": 64516,
	"./GenerationDispatchCenter/routes.tsx": 3659,
	"./Home/routes.tsx": 35021,
	"./IdsBsa/routes.tsx": 31241,
	"./InComingOverview/routes.tsx": 90827,
	"./IndustrialGreenMicBigScreen/routes.tsx": 66051,
	"./InstructionConfig/routes.tsx": 59771,
	"./LineLoss/routes.tsx": 89762,
	"./LoadDispatchCenter/routes.tsx": 78032,
	"./MapStation/routes.tsx": 47067,
	"./MicrogridConfOverview/routes.tsx": 49272,
	"./MicrogridConfigure/routes.tsx": 51634,
	"./MicrogridOverview/routes.tsx": 48770,
	"./MicrogridStrategy/routes.tsx": 56866,
	"./MicrogridTopologyModeling/routes.tsx": 2608,
	"./Mock/routes.tsx": 92526,
	"./OperationAnalysisReport/routes.tsx": 5974,
	"./OperationDataReport/routes.tsx": 55596,
	"./Overview/routes.tsx": 80753,
	"./PVOperationDashBoard/routes.tsx": 17833,
	"./PVPowerForecast/routes.tsx": 64764,
	"./PhotovoltaicMonitoringCenter/routes.tsx": 8324,
	"./PvDemonstrationBase/routes.tsx": 62354,
	"./PvDispersionRate/routes.tsx": 98365,
	"./PvIncomeReport/routes.tsx": 75985,
	"./PvPerformance/routes.tsx": 32823,
	"./PvRunning/routes.tsx": 9689,
	"./PvRunningOverview/routes.tsx": 949,
	"./PvStation/routes.tsx": 79218,
	"./SchedulingTopoDemo/routes.tsx": 72315,
	"./SchedulingTopology/routes.tsx": 26336,
	"./SiteAccess/routes.tsx": 17569,
	"./SitePerforAnalysisYear/routes.tsx": 14979,
	"./Statistics/routes.tsx": 70166,
	"./Storage/routes.tsx": 11590,
	"./StorageOrderConfig/routes.tsx": 77650,
	"./StorageRemoteControl/routes.tsx": 30453,
	"./Strategy/routes.tsx": 50065,
	"./StrategySimulation/routes.tsx": 18139,
	"./StrategyTemplate/routes.tsx": 70984,
	"./SystemVisualizations/routes.tsx": 81475,
	"./TemperRealTimeData/routes.tsx": 19757
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16860;